export default "__VITE_ASSET__8dba42e3__"